import * as React           from 'react'
import { Link }             from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

import Button      from '@material-ui/core/Button'
import Card        from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Grid        from '@material-ui/core/Grid'
import Typography  from '@material-ui/core/Typography'
import Done        from '@material-ui/icons/Done'

import { success } from '../../theme'

const ForgotPasswordSent = () => {
  const phrasing = {
    checkYourInbox:    <FormattedMessage id={'generic.checkYourInbox'} />,
    resetInstructions: <FormattedMessage id={'generic.resetInstructions'} />,
    backToLogin:       <FormattedMessage id={'buttonActions.backToLogin'} />
  }

  return (
    <Card>
      <CardContent>
        <Grid
          container
          spacing={40}
          alignItems={'center'}
          wrap={'nowrap'}
        >
          <Grid item>
            <Done nativeColor={success.main} />
          </Grid>
          <Grid item>
            <Typography variant={'headline'}>
              {phrasing.checkYourInbox}
            </Typography>
            <Typography>
              {phrasing.resetInstructions}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions>
        <Link to={'/'}>
          <Button variant={'raised'} color={'secondary'}>
            {phrasing.backToLogin}
          </Button>
        </Link>
      </CardActions>
    </Card>
  )
}

export default ForgotPasswordSent



// WEBPACK FOOTER //
// ./src/components/organisms/ForgotPasswordSent.tsx